<footer class="footer not-printable">
  <span class="info">
   {{(currentUser$ | async)?.firstName}}  | {{companyName}} |  <a [href]="'/log-changes'" target="_blank" rel="noopener">
    {{ environment.VERSION }}
  </a>
   | <a routerLink="/share-form">Share Form</a>
   | <a routerLink="/audit-logs">Audit Log</a>
   | <a routerLink="/global-requests">Global Requests</a>
   <ng-container *ngxPermissionsOnly="['CorporateAdmin']">
     | <a routerLink="/admin/pending-changes">Pending Changes</a>
   </ng-container>
   | <a href="javascript:void(0)" (click)="openCyprusRegistrySearch()">Cyprus Registry Search</a>
  </span>
</footer>
